// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2PEvH","bigColWidth":"Table_bigColWidth__1v9i_","biggerColWidth":"Table_biggerColWidth__3QUYu","row":"Table_row__1oSLL","col":"Table_col__1GQFM"};